"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimedMomentumGameObject = void 0;
var realms_engine_1 = require("realms-engine");
var TimedMomentumGameObject = /** @class */ (function (_super) {
    __extends(TimedMomentumGameObject, _super);
    function TimedMomentumGameObject(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.onDelayTimerEnd = function () {
            var physics = _this.getPhysicsObject();
            physics.addTranslationForce(_this.translationForce);
            _this.momentumTimer.start(_this.options.duration);
        };
        _this.onMomentumTimerEnd = function () {
            var _a;
            var physics = _this.getPhysicsObject();
            physics.removeTranslationForce(_this.translationForce);
            // Remove from scene
            (_a = _this.getScene()) === null || _a === void 0 ? void 0 : _a.realm.systems.get(realms_engine_1.UtilsSystem).queueAtGameStepEnd(function () {
                physics.queueRemoveChild(_this);
            });
        };
        _this.delayTimer = _this.addChild(new realms_engine_1.TimerGameObject());
        _this.momentumTimer = _this.addChild(new realms_engine_1.TimerGameObject());
        var direction = (0, realms_engine_1.vector3Normalize)(options.direction);
        _this.translationForce = new realms_engine_1.PhysicsTranslationForce({
            x: (direction.x * options.distance * 1000) / options.duration,
            y: (direction.y * options.distance * 1000) / options.duration,
            z: (direction.z * options.distance * 1000) / options.duration,
        });
        return _this;
    }
    TimedMomentumGameObject.prototype.onInit = function (scene) {
        this.delayTimer.addListener("onFinish", this.onDelayTimerEnd);
        this.momentumTimer.addListener("onFinish", this.onMomentumTimerEnd);
        this.delayTimer.start(this.options.delay);
    };
    TimedMomentumGameObject.prototype.onRemove = function (scene) {
        this.delayTimer.removeListener("onFinish", this.onDelayTimerEnd);
        this.momentumTimer.removeListener("onFinish", this.onMomentumTimerEnd);
        // Remove translation force. Handles the case where this momentum object
        // is removed before the translation finishes
        var physics = this.getPhysicsObject();
        physics.removeTranslationForce(this.translationForce);
    };
    TimedMomentumGameObject.prototype.getPhysicsObject = function () {
        var parent = this.getParent();
        if (!(parent instanceof realms_engine_1.Physics3DBodyGameObject)) {
            throw new Error("TimedMomentumGameObject must be the child of a Physics3DBodyGameObject. Instead received ".concat(parent === null ? "null" : parent.getName()));
        }
        return parent;
    };
    return TimedMomentumGameObject;
}(realms_engine_1.GameObject));
exports.TimedMomentumGameObject = TimedMomentumGameObject;
